define('ANSI/Components/QuickAction/QuickActionSelectBox',['jquery'], function ($) {
    'use strict';

    function QuickActionSelectBox(scope) {
        $('.score-button-menu', scope).on('click', function () {
            if (!$('.score-button-menu.open', scope).is(':visible')) {
                $('.score-button-menu', scope).closest('.score-style-box').toggleClass('open');
            } else {
                $('.score-button-menu', scope).closest('.score-style-box').removeClass('open');
            }
        });

        $('.dropdown-menu li a', scope).on('click', function (e) {
            $('.ansi-quick-action .score-style-box', scope).removeClass('open');
            e.preventDefault();
            var selText = $(this).text();
            var ref = $(this).attr('href');
            var target = $(this).attr('target');
            $(this).parents('.score-button-menu').find('.btn').html(selText);
            $('.score-button-menu + .score-button', scope).attr('href', ref);
            $('.score-button-menu + .score-button', scope).attr('target', target);
            $('.score-button-menu + .score-button', scope).removeClass('disabled');
        });

        $(document).on("click", function (e) {
            e.stopPropagation();
            //check if the clicked area is in dropdown
            if ($('.ansi-quick-action .score-style-box', scope).has(e.target).length === 0) {
                $('.score-button-menu', scope).closest('.score-style-box').removeClass('open');
            }
        });
    }

    QuickActionSelectBox.init = function init(args) {
        return args.IsEditorEditing === true ? null : new QuickActionSelectBox(args.scope);
    };

    return QuickActionSelectBox;

});
